import { Component, OnInit } from '@angular/core';
import { GeneralTeacherComponent } from '../../General/gt.component';
import { TopicService } from '../topic.service';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-t-hash',
  templateUrl: './t-hash.component.html',
  styleUrls: ['./t-hash.component.css']
})
export class THashComponent extends GeneralTeacherComponent {

  elementType: string = 'number';
  elements: any[] = [];
  selection: number[];
  typeFunction: string = "checksum";
  scalar: number;
  divisor: number;
  compute: string[];
  hashElements: boolean;
  linearProbing: boolean;

  precomputation: boolean = false;
  operation: boolean = false;
  scale: boolean = false;
  divide: boolean = false;

  fixedElements: boolean = false;
  length: number = 10;
  elementS: string = undefined;
  selectionS: string = undefined;
  text = undefined;
  count: number = undefined;

  useAll = false;

  constructor(protected topicService: TopicService, protected activatedRoute: ActivatedRoute, protected http: HttpClient) {
    super(topicService, activatedRoute);
    this.loadText();
    this.type = "hashElement";
    this.title = this.get("hashElementsTitle");
  }

  /** loads the text to generate words from */
  loadText(): Promise<any> {
    let textFile = "./assets/text_" + this.topicService.getLanguage() + ".txt";
    let self = this;
    return new Promise((resolve, reject) => {
      this.http
        .get<string>(textFile)
        .subscribe(response => {
          self.text = response;
          resolve(true);
        })
    })
  }

  reset() {
    super.reset();
    this.title = this.get("hashElementsTitle");
    this.elementType = "number";
    this.elements = [];
    this.selection = [];
    this.selectionS = undefined;
    this.typeFunction = "addition";
    this.scalar = undefined;
    this.divisor = undefined;
    this.compute = [];
    this.hashElements = false;
    this.linearProbing = false;

    this.elementS = undefined;

    this.fixedElements = false;
    this.length = 10;
    this.count = undefined;
    this.useAll = false;
  }

  /** sets information based on configuration */
  setInformationWithConfiguration() {
    super.setInformationWithConfiguration();
    this.elementType = this.configuration.typespecifics.elementType;
    this.fixedElements = true;
    this.elements = this.configuration.typespecifics.elements;
    this.elementS = this.elements.toString();
    this.scalar = this.configuration.typespecifics.scalar;
    this.title = this.configuration.title;
    this.elementType = this.configuration.typespecifics.elementType;
    this.selection = this.configuration.typespecifics.selection;
    if (this.selection) {
      this.selectionS = this.selection.toString();
    }
    if(!this.selection || this.selection.length == 0){
      this.useAll = true;
    }
    this.typeFunction = this.configuration.typespecifics.typeFunction;
    this.scalar = this.configuration.typespecifics.scalar;
    this.divisor = this.configuration.typespecifics.divisor;
    if(this.typeFunction == "checksum"){
      this.divisor = 10;
    }
    this.hashElements = this.configuration.typespecifics.hashElements;
    this.compute = this.configuration.typespecifics.compute;
    this.linearProbing = this.configuration.typespecifics.linearProbing;

    this.precomputation = this.configuration.typespecifics.compute.includes("precomputation");
    this.operation = this.configuration.typespecifics.compute.includes("operation");
    this.scale = this.configuration.typespecifics.compute.includes("scale");
    this.divide = this.configuration.typespecifics.compute.includes("modulo");
    this.compute = this.configuration.typespecifics.compute;
  }

  /** called when the fixed elements change */
  changeElements() {
    this.elements = this.elementS.split(",");
    if (this.elementType == "number") {
      this.elements = this.elements.map((v) => +v);
    }
    this.elements = Array.from(new Set(this.elements));
    this.elementS = this.elements.toString();
  }

  /** called when the fixed elements change */
  changeSelectionS() {
    this.selection = this.selectionS.split(",").map(v => +v);
    if (this.elementType == 'number') {
      this.selection = this.selection.filter(v => !Number.isNaN(v)).map(v => Math.floor(v));
    }
    this.selection = Array.from(new Set(this.selection));
    this.selectionS = this.selection.toString();
  }

  onChangeFunctionType(){
    if(this.typeFunction == "checksum"){
      this.divisor = 10;
    }
  }

  /** generate the elements*/
  generateElements() {
    if (this.count < (this.elementType == "number" ? 1000 : 370) && (!this.linearProbing || this.count < this.divisor)) {
      this.length = Math.floor(this.length);
      this.count = Math.floor(this.count)
      if (this.definitionForm.controls['elements'].valid &&
        (this.elementType != "number" ||
          (this.definitionForm.controls['length'].valid))) {

        this.elements = [];
        this.computeElements();
      }
    }
  }

  /** computes the elements, inserts the requested one and sorts them increasingly */
  computeElements() {
    if (this.elementType == "number") {
      if (!this.fixedElements) {
        let i = 0;
        while (i < this.count) {
          let elem = "";
          for (var j = 0; j < this.length; j++) {
            elem = elem.concat(Math.floor(Math.random() * 10).toString());
          }
          while (this.elements.includes(elem)) {
            elem = "";
            for (var j = 0; j < length; j++) {
              elem = elem.concat(Math.floor(Math.random() * 10).toString());
            }
          }
          this.elements.push(elem);
          i++;
        }
      }
      this.elements = Array.from(new Set(this.elements));
    } else { // elementType== 'string'
      this.computeElementsText(this.text.text);

    }
  }

  /** returns the maximal selected position */
  maxPosition(): number {
    if (this.elementType == "string") {
      return 10;
    }
    if (this.selection == undefined || this.selection == []) {
      return 1;
    } else {
      return Math.max(...this.selection) + 1;
    }
  }


  /** get random elements based on text */
  computeElementsText(text: string) {
    let words = text.replace(/[.,!:*+?^${}()|[\]\\]/g, "").split(" ").filter(v => v.length > 2).filter(v => v.length < 7);
    words = Array.from(new Set(words));
    while (this.elements.length <= this.count && words.length > 0) {
      let index = Math.ceil(Math.random() * words.length - 1);
      this.elements.push(words[index]);
      words.splice(index, 1);

    }
    this.elements = Array.from(new Set(this.elements.map(v => v.toUpperCase())));
  }

  generateDefinition(): any {
    let definition: any = {};
    definition.typespecifics = {};
    definition.title = this.title;
    definition.type = this.type;
    definition.description = this.description;
    definition.image = "./assets/images/hash.png";
    if (this.typeFunction == 'digits' || this.typeFunction == 'checksum') {
      this.scalar = 0;
    }
    if (this.id == undefined || this.id == null) {
      definition.id = this.topicService.getMaxId(this.examId) + 1;
    } else {
      definition.id = this.id;
    }
    this.id = definition.id;
    definition.key = "searchAndOrder%".concat(this.type, "%");
    if (this.examId > -1) {
      definition.key = definition.key.concat("exam%", this.examId.toString(), "%");
    }
    definition.typespecifics.elements = this.elements;
    definition.key = definition.key.concat("%", this.elements.toString(), "%", this.typeFunction, "%", this.scalar.toString(), "%", this.divisor.toString());
    definition.typespecifics.elementType = this.elementType;
    if (this.useAll) {
      definition.typespecifics.selection = [];
    } else {
      definition.typespecifics.selection = this.selection;
    }
    definition.typespecifics.typeFunction = this.typeFunction;
    definition.typespecifics.scalar = this.scalar;
    definition.typespecifics.divisor = this.divisor;
    definition.typespecifics.hashElements = this.hashElements;
    definition.typespecifics.compute = this.compute;
    definition.typespecifics.linearProbing = this.linearProbing;

    definition.typespecifics.compute = [];
    if (this.precomputation) { definition.typespecifics.compute.push("precomputation") }
    if (this.operation) { definition.typespecifics.compute.push("operation") }
    if (this.scale) { definition.typespecifics.compute.push("scale") }
    if (this.divide) { definition.typespecifics.compute.push("modulo") }

    definition.level = (this.linearProbing ? 3 : (definition.typespecifics.compute.length > 0 ? 1 : 2));
    return definition;
  }

  /** returns a string representation of the hash function */
  getHashFunction(): string {
    let separator = "";
    let result = "";
    if (this.typeFunction == 'digits') {
      if (this.selection != undefined) {
        for (let i of this.selection) {
          result = result.concat("a", i.toString());
        }
      }
      return result;
    }
    if (this.typeFunction == "checksum") {
      return this.get("checksum");
    }
    if (this.useAll) {
      if (this.typeFunction == "addition") {
        result = "a0 + a1 + ...";
      } else {
        result = "a0 * a1 * ...";
      }
    } else {

      if (this.selection != undefined) {
        for (let i of this.selection) {
          result = result.concat(separator, "a".concat(i.toString()));
          separator = " * ";
          if (this.typeFunction == "addition") {
            separator = " + ";
          }
        }
      }
    }
    result = "Rest von ((".concat(result, ")", " * ", this.scalar ? this.scalar.toString() : "???", ")", " / ", this.divisor ? this.divisor.toString() : "???")
    return result;
  }


  generate() {
    this.title = this.get("hashElementsTitle");
    this.elementType = Math.random() > 0.5 ? 'number' : "string";
    this.fixedElements = false;
    this.count = Math.floor(Math.random() * 20 + 10);
    this.length = this.elementType == 'number' ? Math.floor(Math.random() * 5 + 5) : 10;
    this.elements = [];
    this.computeElements();

    this.typeFunction = Math.random() > 0.33 ? "digits" : (Math.random() > 0.5 ? "checksum" : (Math.random() > 0.5 ? "multiplication" : "addition"));
    if (this.elementType == "string") {
      this.typeFunction = Math.random() > 0.5 ? "addition" : "multiplication";
    }

    let countSelection = this.typeFunction == 'digits' ? 2 : this.elementType == 'number' ? Math.floor(Math.random() * this.length / 2 + 1) : 3;
    let length = this.elementType == 'number' ? this.length : 5;
    this.selection = [];
    while (this.selection.length < countSelection) {
      let sel = Math.floor(Math.random() * length);
      if (!this.selection.includes(sel)) {
        this.selection.push(sel);
      }
    }
    this.scalar = Math.floor(Math.random() * 30) + 2;
    this.divisor = Math.floor(Math.random() * 20) + this.count;
    this.hashElements = Math.random() > 0.5;
    this.linearProbing = false;

    this.precomputation = Math.random() > 0.5;
    this.operation = Math.random() > 0.8;
    this.scale = Math.random() > 0.2;
    this.divide = Math.random() > 0.2;

    this.selectionS = this.selection.toString();
  }

  /** floors the numbers */
  floor() {
    this.scalar = Math.floor(this.scalar);
    this.divisor = Math.floor(this.divisor);
  }


}
